import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class tableMixin extends Vue {
  public cList: any = [];

  public chapterId: string = '';

  // 添加确认对话框的状态
  public showDeleteConfirm: boolean = false;

  public currentDeleteRow: any = null;

  public column: Array<ITABLECOLCONF> = [{
    label: '类型',
    prop: 'typeLabel',
    align: 'center',
    minWidth: '80px',
  }, {
    label: '题号',
    prop: 'questionId',
    align: 'center',
    minWidth: '60px',
  }, {
    label: '标题',
    prop: 'title',
    align: 'center',
    minWidth: '230px',
    tooltip: true,
  }, {
    label: '知识点',
    prop: 'knowLedges',
    align: 'center',
    minWidth: '100px',
  }, {
    label: '难度',
    prop: 'difficulty',
    align: 'center',
    minWidth: '60px',
  }, {
    label: '来源',
    prop: 'source',
    align: 'center',
    minWidth: '100px',
  }, {
    label: '地区',
    prop: 'area',
    align: 'center',
    minWidth: '80px',
  }, {
    label: '年份',
    prop: 'year',
    align: 'center',
    minWidth: '60px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '150px',
    align: 'center',
    maxBtn: 2,
    btnList: [
      {
        title: '修改',
        name: '/course/info:update',
        icon: 'edit',
        type: 'info',
        disabled: true,
        callback: this.handleEdit,
        log: {
          name: '课后作业 - 修改',
          component: '/course/info:update',
        },
      },
      {
        title: '删除',
        name: '/course/info:remove',
        icon: 'trash-o',
        type: 'danger',
        callback: this.handleRemove,
        log: {
          name: '课后作业 - 删除',
          component: '/course/info:remove',
        },
      },
    ],
  }]

  public loading: boolean = false;

  private questions: any = [];

  private difficulties: any = [];

  private knowledges: any = [];

  getData(pid: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.loading = true;
      api.getChapterAssignment(pid).then((res: any) => {
        const typeMap: Record<number, string> = {
          0: '选择题',
          1: '判断题',
          2: '多选题',
          3: '填空题',
          4: '编程题',
          5: '阅读程序题',
          6: '问答题',
        };

        // 处理新的数据结构
        const processedData = (res || []).map((item: any) => {
          const question = item.ojQuestion || {};
          const type = Number(question.type);
          return {
            ...question,
            assignmentPid: item.assignmentPid, // 保留assignmentPid用于删除
            type,
            typeLabel: typeMap[type] || '未知类型',
          };
        });

        // 按题目类型排序：0-选择题, 1-判断题, 2-多选题, 3-填空题, 4-编程题, 5-阅读程序题, 6-问答题
        const sortedData = processedData.sort((a, b) => a.type - b.type);

        this.cList = sortedData;
        this.chapterId = pid;
        this.loading = false;
        resolve(sortedData);
      }).catch((err) => {
        this.loading = false;
        reject(err);
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  handleOperate(row: any) {}

  handleContent(row: any) {
    this.msg('功能待开发', 'warning');
  }

  handleRemove(row: any) {
    // 显示内联确认对话框
    this.currentDeleteRow = row;
    this.showDeleteConfirm = true;
  }

  // 确认删除
  confirmDelete() {
    if (!this.currentDeleteRow) return;

    const row = this.currentDeleteRow;
    this.showDeleteConfirm = false;
    this.currentDeleteRow = null;

    // 执行删除操作
    api.removeAssignment([row.assignmentPid]).then(() => {
      this.msg('删除成功', 'success', {
        duration: 3000,
        zIndex: 99999,
        position: 'top-center',
      });
      this.getData(this.chapterId);
      this.$log({
        title: '课后作业 - 删除 - 确定',
        component: 'course/chapter/assignment',
      });
    }).catch((error) => {
      console.error('删除失败:', error);
      this.msg('删除失败，请重试', 'error', {
        duration: 3000,
        zIndex: 99999,
        position: 'top-center',
      });
    });
  }

  // 取消删除
  cancelDelete() {
    this.showDeleteConfirm = false;
    this.currentDeleteRow = null;
    this.$log({
      title: '课后作业 - 删除 - 取消',
      component: 'course/chapter/assignment',
    });
  }
}
